<template>
  <el-card class="card-main">
    <el-form ref="searchInfo" :model="searchInfo" class="global-form" :inline="true">
      <el-form-item prop="orderTypeName">
        <el-input v-model="searchInfo.orderTypeName" placeholder="请输入工单类型" />
      </el-form-item>
      <el-form-item prop="orderTypeStatus">
        <el-select v-model="searchInfo.orderTypeStatus" placeholder="请选择状态" clearable>
          <el-option label="启用" value="1"></el-option>
          <el-option label="禁用" value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSearch" class="medium">查询</el-button>
      </el-form-item>
    </el-form>
    <el-button class="mb20" size='small' @click='onAdd' type="primary" icon='el-icon-plus'
      v-show="$ButtonShow('WOT_ADD_01')">新增工单类型</el-button>
    <el-table class="global-table" stripe v-loading="tableData.loading" :data="tableData.data">
      <el-table-column :label="item.label" :prop="item.prop" :min-width="item.minWidth || ''"
        :show-overflow-tooltip="item.showOverflowTooltip || false" v-for="(item, index) in tableData.tr" :key="index">
        <template v-slot="{ row }">
          <template v-if="item.prop === 'orderTypeStatus'">
            <span>{{ row.orderTypeStatus === '1' ? '启用' : '禁用' }}</span>
          </template>
          <span v-else>{{ row[item.prop] }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="160px" fixed="right">
        <template v-slot="{ row }">
          <el-button type="text" @click="onDetail(row)">查看</el-button>
          <el-button type="text" @click="onEdit(row.orderType)" v-show="$ButtonShow('WOT_EDT_01')">编辑</el-button>
          <el-button type="text" @click="onSwitch(row)" v-show="$ButtonShow('WOT_EDT_02')">{{ row.orderTypeStatus ===
            '1' ? '禁用' : '启用' }}</el-button>
          <el-button type="text" @click="onDelete(row.orderType)" v-show="$ButtonShow('WOT_DEL_02')">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <GlobalPagination @current-change="getData" @size-change="getData" :current-page.sync="page" :page-size.sync="size"
      :total="total">
    </GlobalPagination>
    <!-- 新增/编辑工单类型弹窗 -->
    <el-dialog title="工单配置" :visible.sync="isShow" @close='closeAdd' width='450px' :destroy-on-close="true"
      :close-on-click-modal='false'>
      <div v-if="editShow">
        <el-form ref="addForm" class="global-form2" :model="addForm" :rules="addRules" label-width="100px">
          <el-form-item label="工单类型" prop="orderTypeName" class="widths">
            <el-input show-word-limit :maxlength="10" v-model="addForm.orderTypeName" placeholder="请输入工单类型" />
          </el-form-item>
          <el-form-item label="所属项目" prop="projectIdList" class="widths">
            <el-select v-model="addForm.projectIdList" placeholder="请选择所属项目（多选）" multiple filterable>
              <el-option v-for="(item, i) in normalProjectList" :key="i" :label="item.projectName"
                :value="item.projectId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="反馈人角色" prop="roleOwnIdList" class="widths">
            <el-select v-model="addForm.roleOwnIdList" placeholder="请选择反馈人角色（多选）" multiple filterable>
              <el-option v-for="(item, i) in roleList" :key="i" :label="item.roleName" :value="item.roleId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="审核人角色" prop="roleTwoIdList" class="widths">
            <el-select v-model="addForm.roleTwoIdList" placeholder="请选择审核人角色（多选）" multiple filterable>
              <el-option v-for="(item, i) in roleList" :key="i" :label="item.roleName" :value="item.roleId"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div class="text-center">
          <el-button type="primary" @click="addInspection" :disabled="isAdding">保存</el-button>
          <el-button @click="closeAdd">取消</el-button>
        </div>
      </div>
      <template v-else>
        <el-form class="global-form2" :model="addForm" label-width="100px">
          <el-form-item label="工单类型" class="widths">
            <span class="colors">{{ addForm.orderTypeName }}</span>
          </el-form-item>
          <el-form-item label="所属项目" class="widths mb10">
            <div class="nameList">
              <div class="nameItem" v-for="(item, index) in getNameLit(addForm.projectName)" :key="index">{{ item }}</div>
            </div>
          </el-form-item>
          <el-form-item label="反馈人角色" class="widths mb10">
            <div class="nameList">
              <div class="nameItem" v-for="(item, index) in getNameLit(addForm.roleOwnName)" :key="index">{{ item }}</div>
            </div>
          </el-form-item>
          <el-form-item label="审核人角色" class="widths mb10">
            <div class="nameList">
              <div class="nameItem" v-for="(item, index) in getNameLit(addForm.roleTwoName)" :key="index">{{ item }}</div>
            </div>
          </el-form-item>
          <el-form-item label="创建人">
            <span class="colors">{{ addForm.createUserName }}</span>
          </el-form-item>
          <el-form-item label="创建时间">
            <span class="colors">{{ addForm.ctime }}</span>
          </el-form-item>
        </el-form>
      </template>
    </el-dialog>
  </el-card>
</template>

<script>
import { validateMinLength } from '@/utils/validate'

export default {
  name: 'OrderDeploy',
  data () {
    return {
      searchInfo: {
        orderTypeName: '',
        orderTypeStatus: ''
      },

      tableData: {
        loading: false,
        tr: [
          {
            label: '工单类型',
            prop: 'orderTypeName',
            minWidth: '100',
            showOverflowTooltip: true
          },
          {
            label: '归属项目',
            prop: 'projectName',
            minWidth: '100',
            showOverflowTooltip: true
          },
          {
            label: '反馈人角色',
            prop: 'roleOwnName',
            minWidth: '100',
            showOverflowTooltip: true
          },
          {
            label: '审核人角色',
            prop: 'roleTwoName',
            minWidth: '100',
            showOverflowTooltip: true
          },
          {
            label: '状态',
            prop: 'orderTypeStatus',
            minWidth: '100',
            showOverflowTooltip: true
          },
          {
            label: '创建人',
            prop: 'createUserName',
            minWidth: '100',
            showOverflowTooltip: true
          },
          {
            label: '创建时间',
            prop: 'ctime',
            minWidth: '100',
            showOverflowTooltip: true
          }
        ],
        data: []
      },

      total: 0,
      page: 1,
      size: 10,
      editShow: false,
      isShow: false,
      isAdding: false,
      roleList: [],
      addForm: {
        orderTypeName: '',
        projectIdList: [],
        roleOwnIdList: [],
        roleTwoIdList: []
      },

      addRules: {
        orderTypeName: [
          { required: true, message: '请输入工单类型名称', trigger: 'change' },
          { validator: validateMinLength, message: '工单类型最少为4个字符', trigger: ['blur', 'change'] }
        ],
        projectIdList: [
          { required: true, message: '请选择所属项目（多选）', trigger: 'change' }
        ],
        roleOwnIdList: [
          { required: true, message: '请选择反馈人角色（多选）', trigger: 'change' }
        ],
        roleTwoIdList: [
          { required: true, message: '请选择审核人角色（多选）', trigger: 'change' }
        ]
      }
    }
  },
  computed: {
    normalProjectList () {
      // return this.$store.state.normalProjectList
      return this.$store.state.projectList
    }

  },

  created () {
    this.getData()
  },
  methods: {
    getData () {
      this.tableData.loading = true
      this.$axios.get(this.$apis.workOrder.selectWorkOrderTypeByList, {
        ...this.searchInfo,
        page: this.page,
        size: this.size
      }).then((res) => {
        this.total = res.total || 0
        this.tableData.data = res.list || []
      }).finally(() => {
        this.tableData.loading = false
      })
    },

    onSearch () {
      this.page = 1
      this.getData()
    },

    // 新增
    onAdd () {
      this.addForm = {
        orderTypeName: '',
        projectIdList: [],
        roleOwnIdList: [],
        roleTwoIdList: []
      }
      this.editShow = true
      this.isShow = true
      // 获取人员列表
      this.getRoleList()
    },

    // 编辑
    onEdit (orderType) {
      this.editShow = true
      this.getRoleList()
      this.getDetail(orderType)
      this.isShow = true
    },

    // 获取详情
    getDetail (orderType) {
      this.$axios.get(this.$apis.workOrder.selectWorkOrderTypeByType, {
        orderType: orderType
      }).then(res => {
        this.addForm = res || {}
      })
    },

    // 关闭添加弹框
    closeAdd () {
      this.$nextTick(() => {
        this.$refs.addForm && this.$refs.addForm.clearValidate()
      })
      this.editShow = false
      this.isShow = false
    },

    addInspection () {
      this.$refs.addForm.validate(valid => {
        if (valid) {
          this.isAdding = true
          const url = this.addForm.orderType ? this.$apis.workOrder.updateWorkOrderType : this.$apis.workOrder.insertWorkOrderType
          this.$axios.post(url, {
            ...this.addForm
          }).then(() => {
            this.$message.success('添加成功')
            this.closeAdd()
            this.onSearch()
          }).finally(() => {
            this.isAdding = false
          })
        }
      })
    },

    getRoleList () {
      this.$axios.get(this.$apis.common.getRoleList).then((res) => {
        this.roleList = res
      })
    },

    onDetail (order) {
      this.addForm = order
      this.editShow = false
      this.isShow = true
    },

    getNameLit (nameList) {
      if (nameList) {
        return nameList.split(',')
      }
    },

    onSwitch (row) {
      const txt = row.orderTypeStatus === '1' ? '禁用' : '启用'
      this.$confirm('确认' + txt + '吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.$apis.workOrder.onOffWorkOrderType, {
          orderType: row.orderType
        }).then(() => {
          this.$message.success(txt + '成功')
          this.onSearch()
        })
      })
    },

    onDelete (orderType) {
      this.$confirm('确认删除吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.$apis.workOrder.deleteDataWorkOrderType, {
          orderType: orderType
        }).then(() => {
          this.$message.success('删除成功')
          this.onSearch()
        })
      })
    }
  }

}
</script>

<style scoped lang="scss">
::v-deep .widths {
  .el-input {
    width: 300px !important;
  }
}

.nameList {
  display: flex;
  flex-wrap: wrap;

  .nameItem {
    height: 30px;
    background: #FAFAFB;
    border-radius: 2px;
    padding: 4px 10px;
    font-size: 14px;
    color: #333333;
    line-height: 22px;
    margin-right: 10px;
    margin-bottom: 10px;
  }
}

.colors {
  color: #333333;
}

.mb10 {
  margin-bottom: 10px;
}
</style>
